import UpdateConfiguration from "./UpdateConfiguration";

export default UpdateConfiguration;
